<template>
  <section class="dashboard section is-full-touch is-full mobile">
    <div class="container is-fluid-desktop is-full-touch is-full-mobile">
      <div class="is-hidden-desktop is-hidden-widescreen">
        <Mobilemenu/>
      </div>
      <div class="columns">
        <div
            class="column is-narrow-desktop is-hidden-mobile is-hidden-touch sbar"
        >
          <Sidebar/>
        </div>
        <div class="column">
          <div class="block">
            <h1 class="title block">Members</h1>
            <h2 class="subtitle block">
              Manage members and member settings
            </h2>
          </div>
          <div class="block">
            <div class="field is-grouped">
              <div class="control">
                <button @click="purgeInactiveMembers()" class="button is-danger" disabled>Purge inactive members</button>
              </div>
              <div class="control">
                <button @click="purgeExpiredMembers()" class="button is-danger" disabled>Purge expired members</button>
              </div>
            </div>
          </div>
          <div class="block">
            <h2 class="title is-5">Reset payment addresses</h2>
            <p class="block">
              Clear stored deposit addresses so members receive a new one the next time they open the deposit screen.
              Old addresses may still accept payments until members request a new address.
            </p>
            <div class="field">
              <label v-for="chain in paymentChains" :key="chain.id" class="checkbox block">
                <input
                    v-model="selectedChains"
                    type="checkbox"
                    :value="chain.id"
                >
                {{ chain.label }}
              </label>
            </div>
            <div class="field is-grouped">
              <div class="control">
                <button
                    class="button is-danger"
                    :class="{ 'is-loading': resetLoading }"
                    :disabled="selectedChains.length === 0 || resetLoading"
                    @click="resetPaymentAddresses()"
                >
                  Reset selected payment addresses
                </button>
              </div>
            </div>
            <p v-if="resetResult" class="has-text-success">
              Cleared addresses for {{ resetResult.cleared }} members
              ({{ resetResult.chains.join(', ') }}).
            </p>
            <p v-if="resetError" class="has-text-danger">
              {{ resetError }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Mobilemenu from "@/components/Mobilemenu";
import AccountService from "@/services/AccountService";

export default {
  name: "SettingsMembersView",
  components: {
    Sidebar,
    Mobilemenu
  },
  data() {
    return {
      paymentChains: [
        { id: 'erc20', label: 'ERC20 (USDT)' },
        { id: 'trc20', label: 'TRC20 (USDT/USDC)' },
        { id: 'bep20', label: 'BEP20 (USDT/USDC)' },
        { id: 'polygon', label: 'Polygon (USDT/USDC)' },
        { id: 'btc', label: 'BTC' },
      ],
      selectedChains: [],
      resetLoading: false,
      resetResult: null,
      resetError: null,
    }
  },
  methods: {
    async purgeInactiveMembers() {
      try {
        if (confirm('Are you sure you want to purge inactive members?')) {
          // const r = await AccountService.purgeInactiveMembers()
          // console.log(r)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async purgeExpiredMembers() {
      try {
        if (confirm('Are you sure you want to purge expired members?')) {
          // const r = await AccountService.purgeExpiredMembers()
          // console.log(r)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async resetPaymentAddresses() {
      const chainLabels = this.paymentChains
          .filter(chain => this.selectedChains.includes(chain.id))
          .map(chain => chain.label)
          .join(', ')

      if (!confirm(`Reset payment addresses for all members?\n\nChains: ${chainLabels}\n\nMembers will get a new address the next time they open the deposit screen.`)) {
        return
      }

      try {
        this.resetLoading = true
        this.resetResult = null
        this.resetError = null
        const res = await AccountService.resetPaymentAddresses(this.selectedChains)
        this.resetResult = res.data.data
      } catch (e) {
        console.log(e)
        this.resetError = 'Failed to reset payment addresses. Check the console for details.'
      } finally {
        this.resetLoading = false
      }
    },
  }
}
</script>
